var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100",
    transform: "translate(19315.342)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 24,
    height: 24,
    transform: "translate(-19315.342)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099",
    transform: "translate(-19313.342 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094",
    transform: "translate(2.969 4.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M80.674,112.33,79.5,106.471a.586.586,0,0,0-.575-.471H77.756a.586.586,0,0,0-.575.471l-1.172,5.859a.586.586,0,0,0,1.149.23l.375-1.873H79.15l.375,1.873a.586.586,0,0,0,1.149-.23Zm-2.907-2.815.469-2.344h.211l.469,2.344Z",
    transform: "translate(-75.998 -106)",
    fill: "#15345a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    transform: "translate(11.758 7.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M306.273,197.172h-1.758v-.586a.586.586,0,0,0-1.172,0v.586h-1.758a.586.586,0,0,0,0,1.172h.142a7.331,7.331,0,0,0,1.39,2.57c-.45.412-.906.749-1.312,1.074a.586.586,0,1,0,.732.915c.408-.326.9-.689,1.392-1.143.495.454.985.818,1.392,1.143a.586.586,0,0,0,.732-.915c-.4-.324-.861-.662-1.312-1.074a7.331,7.331,0,0,0,1.39-2.57h.142a.586.586,0,0,0,0-1.172Zm-2.344,2.881a6.172,6.172,0,0,1-.964-1.713h1.928A6.171,6.171,0,0,1,303.93,200.053Z",
    transform: "translate(-301 -196)",
    fill: "#15345a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M18.242,3.555H9.789L9.538,1.54A1.761,1.761,0,0,0,7.794,0H1.758A1.76,1.76,0,0,0,0,1.758v12.93a1.76,1.76,0,0,0,1.758,1.758H6.7l.248,2.015A1.762,1.762,0,0,0,8.691,20h9.551A1.76,1.76,0,0,0,20,18.242V5.313A1.76,1.76,0,0,0,18.242,3.555ZM1.758,15.273a.587.587,0,0,1-.586-.586V1.758a.587.587,0,0,1,.586-.586H7.794a.587.587,0,0,1,.581.513l1.694,13.589Zm6.317,2.764-.2-1.592H9.451Zm10.753.205a.587.587,0,0,1-.586.586H8.94l2.231-2.58a.585.585,0,0,0,.142-.47L9.935,4.727h8.307a.587.587,0,0,1,.586.586Z",
    fill: "#15345a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/languageIcon.1f54ca80070ad1924df84c428a4e02e5.svg";
export { ForwardRef as ReactComponent };